// extracted by mini-css-extract-plugin
export default {"Wrapper":"Wrapper_Wrapper__bHgJb"};